import _extends from 'babel-runtime/helpers/extends';

export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },

  data: function data() {
    return {
      innerCurrentPage: this.currentPage
    };
  },


  computed: {
    innerAttrs: function innerAttrs() {
      return _extends({
        background: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: this.pageSize,
        pageSizes: [15, 20, 50, 100, 200, 300, 400]
      }, this.$attrs);
    }
  },

  watch: {
    currentPage: function currentPage(val) {
      console.log('watch:', val);
      this.innerCurrentPage = val;
    }
  },

  methods: {}
};